import React from "react";
import styled from "styled-components";
import Spinner from "./Spinner";

export const HEIGHT = 28;

const StyledRecordingStatusBar = styled.div`
  padding: 0 0.5rem;
  height: ${HEIGHT}px;
  line-height: ${HEIGHT}px;
  text-align: center;
  background: ${props => props.theme.colors.gray2};
  font-size: 0.85rem;
  position: fixed;
  z-index: 2;
  width: 100%;
`;

interface Props {
  loading: boolean;
  query: string;
  onStop?: () => void;
  fixedPosition?: boolean;
}

const RecordingStatusBar: React.FC<Props> = ({ loading, onStop, query, fixedPosition = true }) => {
  const renderLoadingState = () => (
    <>
      <Spinner /> Recording {query},{" "}
      <span className="link" onClick={() => onStop && onStop()}>
        press to stop
      </span>
    </>
  );

  const renderNonLoadingState = () => <>Recording for {query}</>;

  return (
    <StyledRecordingStatusBar style={{ position: fixedPosition ? "fixed" : "static" }}>
      {loading ? renderLoadingState() : renderNonLoadingState()}
    </StyledRecordingStatusBar>
  );
};

export default RecordingStatusBar;
